package com.ervasstudio.tracoemovimento.model

data class GoogleUser(
    val uid: String,
    val displayName: String?,
    val email: String?,
    val photoUrl: String?,
)